import { render, staticRenderFns } from "./overviewFeratelHuis.vue?vue&type=template&id=1e50949d"
import script from "./overviewFeratelHuis.vue?vue&type=script&lang=js"
export * from "./overviewFeratelHuis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports